import * as React from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import '@sweetalert2/themes/dark';


const PostMapLoc = () => {
  const [myPos, setMyPos] = React.useState({ lat: 0, lng: 0 });
  const [lat, setLat] = React.useState('0');
  const [lng, setLong] = React.useState('0');
  const updtSecCoords = 1;

  const getCoords = async (p0?: () => void) => {
    const geolocAPI = navigator.geolocation;
    const pos = await new Promise(() => {
      geolocAPI.getCurrentPosition(success, error);
      function success(pos: any) {
        setLat(pos.coords.latitude);
        setLong(pos.coords.longitude);
      }
      function error(err: any) {
        console.error(err.code + " --- " + err.Message);
      }
    })
    return pos;
  };

  React.useEffect(() => {
    const interval1 = setInterval(async () => {
      getCoords();
      setMyPos({ lat: parseFloat(lat), lng: parseFloat(lng) });
    }, (updtSecCoords * 1000));
    return () => clearInterval(interval1);
  }, [lat, lng]);

  return (
    //onCameraChanged={ (ev = MapCameraChangedEvent) => console.log('camera changed:', ev.detail.center, 'zoom:', ev.detail.zoom) }
    <>
      <AdvancedMarker
        key={"MyLoc"}
        position={myPos}
        clickable={true}
        onClick={() => {
          Swal.fire({
            title: "This is where you are!",
            html: `Latitude: ` + myPos.lat + `<br />
              Longitude: `+ myPos.lng,
            icon: "info",
            toast: true,
            position: 'top-right',
          });
        }}
        title={"My Current Location"}
        zIndex={3}>
        <div className="myLocation">
        </div>
      </AdvancedMarker>
    </>
  )
}

export default PostMapLoc;